module.exports = __webpack_public_path__ + "static/img/time-line-mob-red.d0d8b32.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/red-about/time-line-mob-red.png
// module id = 1062
// module chunks = 173